import React, { useState } from 'react';

import {
  View,
  Text,
  ScrollView,
  Image,
  FormField,
  LargeButton,
  TouchableOpacity,
} from '../../app-components';

import { getUser, changePassword } from '../../AppServices';
import { validateConfirmPassword, validatePassword } from '../../Lib/helpers';
import { TextInput } from '../../app-components/input-components/Editors';
import { Form } from '../../app-components/form/Form';
import { LANDING_VIEW } from '../../Config';

import { backCrossIcon, notificationError } from '../../images';
import loginStyle from './loginStyle';
import { isMobile } from '../../app-components/UtilityFunctions';
import { h10_Montessart } from '../../theme/fonts';

export default ({ images }) => {
  return ({ navigation }) => {
    const [errorMessage, setErrorMessage] = useState('');
    const handleSubmit = ({ data }) => {
      changePassword({ ...data, user: getUser() }).then((res) => {
        if (res?.message === 'Password changed successfully') {
          navigation.replace(LANDING_VIEW);
        }
      });
    };
    return (
      <ScrollView>
        <TouchableOpacity
          style={{
            alignItems: 'flex-end',
            top: 20,
            right: 10,
            cursor: 'pointer',

            paddingBottom: 20,
          }}
          onPress={() => {
            navigation.pop();
          }}>
          <Image
            style={{ cursor: 'pointer' }}
            source={backCrossIcon}
            width={26}
            height={26}
          />
        </TouchableOpacity>
        <View
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: '85vh',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100vh',
            // marginTop: 50,
            // flexDirection: !isMobile ? 'row' : 'column',
          }}>
          <Form
            mandatory={{
              oldPassword: 'This field cannot be left empty',
              newPassword: 'This field cannot be left empty',
              confirmPassword: 'This field cannot be left empty',
            }}
            showsVerticalScrollIndicator={false}
            onSubmit={handleSubmit}
            containerStyle={{
              flex: 1,
              overflow: 'hidden',
            }}
            bodyContainerStyle={{
              margin: 0,
            }}
            // closeView={1}
            validations={{
              newPassword: ({ data }) => validatePassword(data.newPassword),
              confirmPassword: ({ data }) => validateConfirmPassword(data),
            }}>
            <ChangePasswordNew
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
              navigation={navigation}
            />
          </Form>
        </View>
      </ScrollView>
    );
  };
  // return ChangePassword;
};

const ChangePasswordNew = ({ form_context, errorMessage, navigation }) => {
  const { handleSubmit } = form_context;
  const { errorStyle, loginText } = loginStyle;
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}>
      <View
        style={{
          width: !isMobile && 450,
          gap: 20,
          paddingBottom: 20,
          marginLeft: 100,
          marginRight: 100,
        }}>
        <View
          style={{
            alignItems: 'center',
            marginBottom: 40,
          }}>
          <Text style={{ ...loginText, marginTop: 30 }}>Change Password</Text>
        </View>
        {getUser() && (
          <View style={{ marginBottom: 21 }}>
            <FormField
              field="oldPassword"
              variant="filled"
              floatingLabelStyle={{
                ...h10_Montessart,
              }}
              activeLabelStyle={{
                ...h10_Montessart,
              }}
              label={'changePassword.labels.oldPassword'
                .getLabel()
                .toUpperCase()}
              style={{
                borderRadius: 10,
                border: '1px solid rgba(152, 152, 178, 0.3)',
              }}>
              <TextInput inputProps={{ type: 'password' }} />
            </FormField>
          </View>
        )}
        <View>
          <FormField
            field="newPassword"
            variant="filled"
            floatingLabelStyle={{
              ...h10_Montessart,
            }}
            activeLabelStyle={{
              ...h10_Montessart,
            }}
            label={'resetPassword.labels.newPassword'.getLabel().toUpperCase()}>
            <TextInput inputProps={{ type: 'password' }} />
          </FormField>
        </View>
        <View style={{ marginTop: 21 }}>
          <FormField
            field="confirmPassword"
            variant="filled"
            floatingLabelStyle={{
              ...h10_Montessart,
            }}
            activeLabelStyle={{
              ...h10_Montessart,
            }}
            label={'resetPassword.labels.confirmPassword'
              .getLabel()
              .toUpperCase()}>
            <TextInput inputProps={{ type: 'password' }} />
          </FormField>
        </View>
        <View
          style={{
            marginTop: 21,
            fontSize: '16px',
            fontFamily: 'Roboto',
          }}>
          <Text
            style={{
              fontStyle: 'italic',
            }}>
            Your password should contain
          </Text>
          <Text
            style={{
              fontStyle: 'italic',
            }}>
            - Minimum 8 and Maximum 30 characters
          </Text>
          <Text
            style={{
              fontStyle: 'italic',
            }}>
            - At least one letter(a-z A-Z), one numeric digit(0-9), and one
            special character.
          </Text>
        </View>
        <View
          style={{
            marginTop: 35,
            marginBottom: 10,
            alignItems: 'center',
          }}>
          <LargeButton
            color="#444444"
            hoverColor={null}
            width="120px"
            label={'resetPassword.buttons.save'.getLabel()}
            labelStyle={{
              fontSize: 16,
              color: '#fff',
              fontFamily: 'Montessart',
            }}
            onClick={handleSubmit}
            height={48}
            borderRadius={100}
          />
        </View>

        {errorMessage ? (
          <View
            style={{
              flexDirection: 'row',
              marginTop: 27,
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            <Image
              source={notificationError}
              style={{ height: 18, width: 18 }}
            />
            <Text style={{ ...errorStyle }}>{errorMessage}</Text>
          </View>
        ) : null}
      </View>
    </View>
  );
};
